import React, { createContext } from "react";
import { Auth } from "../helpers/api";
import Cookies from "js-cookie";
import  secureLocalStorage  from  "react-secure-storage";
import { sendNotification } from "../helpers/notification";

export const AuthContext = createContext();

const setToken = (token) => {
  Cookies.set("jwt", token, { expires: 1 });
};

export class AuthProvider extends React.Component {
  state = {
    setUser: (user) => this.setState({ user }),
    login: () => {
      return Auth.login(
        this.state.email,
        this.state.password,
        this.state.code
      ).then((res) => {
        setToken(res.body.token);
        secureLocalStorage.setItem("role", res.body.user.role);
        this.state.setUser(res.body.user);
        sendNotification(
          "success",
          "Привет 👋",
          "Вы успешно авторизованы"
      );
        return res.body.user;
      }).catch((error) => {
        console.log("error", JSON.stringify(error, null, 4));
        sendNotification("warning", "Ошибка ⛔️", error?.response?.body?.message);
        throw Error(error?.response?.body?.message)
      });
    },
    updateState: async (key, val) =>
      await this.setState((state) => {
        state[key] = val;
        return state;
      }),
    user: {},
    email: "",
    password: "",
    code: null,
  };

  render() {
    return (
      <AuthContext.Provider value={this.state}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export const AuthConsumer = AuthContext.Consumer;